import { Check, Minus, Plus } from "lucide-react";
import { Slider } from "../ui/slider";
import { PACKAGES, EXTRA_PLUSH_PRICE, brl } from "../../lib/data";

export const StepPackage = ({ form, set }) => {
  const current = PACKAGES.find((p) => p.id === form.packageId);
  return (
  <div className="space-y-8" data-testid="checkout-step-1-package-select">
    <div className="grid gap-3">
      {PACKAGES.map((p) => {
        const on = form.packageId === p.id;
        return (
          <button key={p.id} type="button" onClick={() => { set("packageId", p.id); if (p.noExtras) set("extras", 0); }} data-testid={`checkout-package-${p.id}`}
            className={`text-left rounded-2xl border p-5 flex items-center gap-5 transition-colors ${on ? "border-[#FFD200] bg-[#FFD200]/10" : "border-white/10 hover:border-white/30"}`}>
            <span className={`w-6 h-6 rounded-full border-2 grid place-items-center shrink-0 ${on ? "border-[#FFD200] bg-[#FFD200]" : "border-white/30"}`}>
              {on && <Check className="w-4 h-4 text-[#08080C]" />}
            </span>
            <span className="flex-1">
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{p.label}</span>
              <span className="block font-display font-bold text-lg text-white">{p.name}</span>
              <span className="block text-sm text-zinc-400">{p.short}</span>
            </span>
            <span className="font-display font-black text-lg md:text-xl text-white">{brl(p.price)}</span>
          </button>
        );
      })}
    </div>
    {!current?.noExtras && <div className="rounded-2xl border border-white/10 p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="font-display font-bold text-white">Pelúcias extras</p>
          <p className="text-sm text-zinc-400">{brl(EXTRA_PLUSH_PRICE)} por unidade</p>
        </div>
        <div className="flex items-center gap-2">
          <button type="button" data-testid="extra-plush-minus" onClick={() => set("extras", Math.max(0, form.extras - 5))}
            className="w-10 h-10 rounded-full border border-white/15 grid place-items-center hover:border-[#FFD200]"><Minus className="w-4 h-4" /></button>
          <input data-testid="extra-plush-input" type="number" min={0} max={1000} value={form.extras}
            onChange={(e) => set("extras", Math.min(1000, Math.max(0, parseInt(e.target.value || "0", 10))))}
            className="w-16 h-10 text-center rounded-xl bg-white/5 border border-white/10 font-display font-bold text-white" />
          <button type="button" data-testid="extra-plush-plus" onClick={() => set("extras", Math.min(1000, form.extras + 5))}
            className="w-10 h-10 rounded-full border border-white/15 grid place-items-center hover:border-[#FFD200]"><Plus className="w-4 h-4" /></button>
        </div>
      </div>
      <Slider data-testid="plushie-calculator-slider" className="mt-6" min={0} max={200} step={5}
        value={[Math.min(200, form.extras)]} onValueChange={([v]) => set("extras", v)} />
      <p className="mt-4 text-sm text-zinc-300">{form.extras} extras = <b className="text-[#FFD200]">{brl(form.extras * EXTRA_PLUSH_PRICE)}</b></p>
    </div>}
  </div>
  );
};
